export const makeShouldForwardProps =
  <T>(propsToSkip: (keyof T)[]) =>
  (propName: string) =>
    !propsToSkip.includes(propName as keyof T);
